import React, { useMemo } from 'react';

import { Modal, TabContainer } from '~components';
import { CompanySettings } from '~support-at-home/components/common';

interface ComponentProps {
  setIsOpen: (val: boolean) => void;
  isOpen: boolean;
}

const CoContributionCompanySettings: React.FC<{ isActive: boolean }> = ({ isActive }) => (
  <CompanySettings isActive={isActive} featureTag="co_contributions" />
);

const CoContributionSettingsModal: React.FC<ComponentProps> = ({ setIsOpen, isOpen }) => {
  const tabs = useMemo(() => [{ id: 'company-settings', title: 'Company Settings', component: CoContributionCompanySettings }], []);
  return (
    <Modal
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      size="xl"
      headerClassName="header"
      header="Co-Contribution Invoice Settings"
      className="co-contribution-settings feature"
      data-cy="co-contribution-settings-modal"
    >
      <TabContainer tabs={tabs} />
    </Modal>
  );
};

export default CoContributionSettingsModal;
